import { Link } from "react-router-dom";
import {
	IconHeartFilled,
	IconSparkles,
	IconFlame,
	IconUsers,
} from "@tabler/icons-react";
import { Card } from "../components/Ui";
import { useAuth } from "@/hooks/useAuth";

export default function Landing() {
	const { isLoaded, isSignedIn } = useAuth();
	return (
		<div className="flex flex-col gap-3">
			<div className="text-center py-6">
				<div className="inline-flex items-center justify-center gap-2 mb-3">
					<IconHeartFilled
						size={40}
						color="var(--color-primary)"
						aria-hidden
					/>
					<h1 className="text-3xl font-extrabold m-0">yayy</h1>
				</div>
				<p className="text-[color:var(--color-text-muted)] text-base">
					Kuis harian untuk mengenal pasanganmu lebih dalam. Jawab 5
					pertanyaan, bandingkan, dan jaga streak cintamu.
				</p>
			</div>

			<div className="grid gap-3 grid-cols-1 sm:grid-cols-2">
				<Feature
					icon={<IconSparkles size={22} color="var(--color-primary)" />}
					title="Kuis harian AI"
					body="5 pertanyaan unik setiap hari, dipilih sesuai kategori pasanganmu."
				/>
				<Feature
					icon={<IconHeartFilled size={22} color="var(--color-primary)" />}
					title="Bandingkan jawaban"
					body="Lihat di mana kalian sinkron dan di mana perlu diskusi."
				/>
				<Feature
					icon={<IconFlame size={22} color="var(--color-primary)" />}
					title="Streak cinta"
					body="Jaga api cinta tetap menyala setiap hari."
				/>
				<Feature
					icon={<IconUsers size={22} color="var(--color-primary)" />}
					title="Pasangan kode"
					body="Buat kode 6 karakter, ajak pasangan gabung. Tanpa email."
				/>
			</div>

			<Card>
				{isLoaded && !isSignedIn && (
					<div className="text-center">
						<h2 className="text-xl font-extrabold m-0">Mulai gratis</h2>
						<p className="text-[color:var(--color-text-muted)] mt-1">
							Daftar dengan email, lalu ajak pasanganmu dengan kode 6 karakter.
						</p>
						<div className="inline-flex gap-3 mt-3">
						<Link to="/login" className="btn btn-secondary">
							Masuk
						</Link>
						<Link to="/register" className="btn btn-primary">
							Daftar
						</Link>
						</div>
					</div>
				)}
				{isLoaded && isSignedIn && (
					<div className="text-center">
						<h2 className="text-xl font-extrabold m-0">
							Selamat datang kembali
						</h2>
						<p className="text-[color:var(--color-text-muted)] mt-1">
							Yuk hubungkan dengan pasanganmu.
						</p>
						<Link to="/onboarding" className="btn btn-primary mt-3">
							Lanjutkan
						</Link>
					</div>
				)}
			</Card>
		</div>
	);
}

function Feature({
	icon,
	title,
	body,
}: {
	icon: React.ReactNode;
	title: string;
	body: string;
}) {
	return (
		<Card>
			<div className="flex items-center gap-2">
				{icon}
				<h3 className="m-0 text-base font-bold">{title}</h3>
			</div>
			<p className="text-[color:var(--color-text-muted)] text-sm mt-1 mb-0">
				{body}
			</p>
		</Card>
	);
}
